import { taskService } from "@miplatform/api";
import { ATTEMPT_STATUSES, HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { CalendarEventType, CalendarType } from "@miplatform/types";
import { getGUIDArray } from "@miplatform/utils";

export const useHoldsPrintModalViewModel = ({
  calendarId,
  templateIds,
  eventType,
  calendarType,
}: {
  calendarId: string;
  eventType: CalendarEventType;
  calendarType: CalendarType;
  templateIds: string[];
}) => {
  const stateManager = useComponentState();

  const getAttempts = () =>
    stateManager.run(async () => {
      const response = await taskService.attempts.getAllWorkOrders({
        filters: {
          attemptStatus: { eq: ATTEMPT_STATUSES.HOLD },
          ...(calendarType !== CalendarType.AutoHold && {
            isOrderFollowupDue: false,
          }),
          assignment: {
            [eventType]: {
              holdCalendarId: {
                type: "guid",
                value: calendarId,
              },
              ...(templateIds?.length > 0 && {
                [`${eventType}TemplateId`]: {
                  in: getGUIDArray(templateIds),
                },
              }),
            },
          },
        },
        sort: "modifiedOn desc",
      });

      if (response.status === HTTP_STATUSES.OK) {
        return response.data;
      }

      return [];
    });

  return {
    isLoading: stateManager.isBusy(),
    getAttempts,
  };
};
